const menuIcon = document.querySelector('#hamburger');

menuIcon.addEventListener('click', function () {
    const slideMenu = document.querySelector('.menu-overlay');
    slideMenu.classList.toggle('active');

    const body = document.querySelector('body');
    body.classList.toggle('noscroll');

    const menuItems = Array.from(slideMenu.querySelectorAll('li a'));
    menuItems.forEach(item => {
        item.addEventListener('click', menuToggleActiveState);
    });
});

const menuClose = document.querySelector('.menu-overlay__close');

menuClose.addEventListener('click', function () {
    menuToggleActiveState();

    const body = document.querySelector('body');
    body.classList.toggle('noscroll');
});

function menuToggleActiveState() {
    const slideMenu = document.querySelector('.menu-overlay');
    slideMenu.classList.toggle('active');
}

const slideMenu = document.querySelector('.menu-overlay');

document.addEventListener('scroll', function () {
    slideMenu.style.top = `${window.scrollY + 82}px !important`;
});
